const hohoConfig = {
  components: {
    button: {
      Button: {

      },
      ButtonSecondary: {

      },
      ButtonText: {

      }
    },
    label: {
      Label: {
        labelColor: 'text-light',
        labelFontSize: 'text-3xs',
        labelTextTransform: 'uppercase',
        labelClasses: 'some-additional-classes-can-be-placed-here'
      }
    },
    heading: {
      Heading: {
        titleFontFamily: 'font-heading',
        titleColor: 'text-primary',
        titleFontSize: 'text-3xl',
        titleFontWeight: 'font-bold',
        titleTextTransform: '',
        titleSpacing: '-tracking-1',
        subtitleFontFamily: 'font-base',
        subtitleColor: 'text-primary',
        subtitleFontSize: 'text-3xs',
        subtitleFontWeight: 'font-bold',
        subtitleTextTransform: 'uppercase',
        subtitleSpacing: 'tracking-widest'
      }
    },
    selectField: {
      SelectField: {
        selectFieldBorder: 'border-ultralight'
      }
    },
    inputField: {
      InputField: {
        inputFieldBorder: 'border-ultralight'
      }
    }
  }
}

export default {
  install: function install () {
    window.$hoho = hohoConfig
  }
}
